import React, { useEffect, useState } from 'react';
import { PageHeaderLeftIcon } from '@shared/infrastructure/ui/components/header/pageHeader';
import { historyRepository } from '@shared/domain/router/router.repository';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ROUTES } from '@shared/infrastructure/router/paths';
import { useAppSelector } from '@shared/infrastructure/state/store';
import {
  countryCodeSelector,
  languageCodeSelector
} from '@shared/infrastructure/state/global.slice';
import { Topic } from '@shared/domain/topic/topic.aggregate';
import { TopicEditLayout } from './topicEdit/topicEditLayout';
import { TopicInfo } from './topicEdit/topicInfo';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Box, Button, IconButton } from '@mui/material';
import { topicRepository } from '@shared/domain/topic/topic.repository';
import { Therapy } from '@shared/domain/therapy/therapy.aggregate';
import { therapyRepository } from '@shared/domain/therapy/therapy.repository';
import { routeRepository } from '@shared/domain/router/route/route.repository';
import { TopicSettings } from './topicEdit/topicSettings';

export const TopicCreate = () => {
  const countryCode = useAppSelector(countryCodeSelector);
  const languageCode = useAppSelector(languageCodeSelector);
  const {} =
    routeRepository.getParams(
      ROUTES.TOPICS_CREATE.path,
      window.location.pathname
    ) || {};

  const [therapies, setTherapies] = useState<Therapy[]>([]);
  useEffect(() => {
    therapyRepository
      .getTherapies(countryCode, languageCode)
      .then((therapies) => {
        setTherapies(therapies || []);
      });
  }, [countryCode, languageCode]);

  const { control, handleSubmit, setError, watch } = useForm<Topic>({
    defaultValues: {
      name: '',
      nameLanguage: ''
    }
  });
  const back = () =>
    historyRepository.push(routeRepository.buildRoute(ROUTES.TOPICS.path, {}));
  const onSubmit: SubmitHandler<Topic> = (data) => {
    topicRepository
      .createTopic(countryCode, languageCode, {
        ...data
      })
      .then(back, (error) => {
        if (error.cause?.response?.status === 409) {
          setError('name', {
            message: 'This identifier is already taken for the selected topic.'
          });
        }
        throw error;
      });
  };
  const name = watch('name');
  const therapyId = watch('therapyId');

  const [therapy, setTherapy] = useState<Therapy>();
  useEffect(() => {
    therapyRepository
      .getTherapies(countryCode, languageCode)
      .then((therapies) => {
        setTherapy(therapies.find((th) => th.id === Number(therapyId)));
      });
  }, [countryCode, languageCode, therapyId]);

  return (
    <>
      <PageHeaderLeftIcon
        icon={
          <IconButton
            size='large'
            color='inherit'
            aria-label='back button'
            sx={{ mr: 2 }}
            onClick={back}
          >
            <ArrowBackIcon fontSize='large' />
          </IconButton>
        }
      >
        <Box sx={{ textAlign: 'center' }}>
          <p>Create topic</p>
          <p>
            <small>
              Country: {countryCode}, Language: {languageCode}
            </small>
          </p>
        </Box>
      </PageHeaderLeftIcon>
      <Box sx={{ textAlign: 'center' }}>
        <p>{`/${countryCode}/${therapy?.name || 'therapy'}/room/${
          name || 'identifier'
        }`}</p>
      </Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <TopicEditLayout
          left={
            <TopicInfo
              topic={undefined}
              therapyName={therapy?.name}
              control={control}
            />
          }
          right={<TopicSettings therapies={therapies} control={control} />}
          buttons={
            <Button
              sx={{
                marginTop: '1rem',
                padding: '1rem 1.5rem'
              }}
              type='submit'
              variant='contained'
              color='primary'
            >
              Create
            </Button>
          }
        />
      </form>
    </>
  );
};
